const Circle3Start = () => {
  return (
    <div className="animate__swing absolute left-[15%] top-[30%] animate__animated">
      <img src="/assets/background/circle-3-start.svg" alt="Dynatech" />
    </div>
  );
};
export default Circle3Start;
